import moment from 'moment';

export type TimestampInMillis = number;
export type TimeIntervalInMillis = number;
export type DurationTimeInSeconds = number;
export type DurationTimeInMillis = number;

export type ISOString = string;

type DateFns = number | Date;

export type DateRangeFns = {
  startDate: DateFns;
  endDate: DateFns;
};

export interface DateRange {
  start: TimestampInMillis;
  end: TimestampInMillis;
}

export interface TimeInterval {
  start: number;
  end: number;
}

export const isSameDateRange = (dateRange1: DateRange, dateRange2: DateRange) => {
  return dateRange1.start === dateRange2.start && dateRange1.end === dateRange2.end;
};

export const getStartOfDayInMillis = (timestampInMillis?: TimestampInMillis) => moment(timestampInMillis).startOf('day').valueOf();

export const getEndOfDayInMillis = (timestampInMillis?: TimestampInMillis) => moment(timestampInMillis).endOf('day').valueOf();

export const getTodayDateRange = (): DateRange => ({
  start: getStartOfDayInMillis(),
  end: getEndOfDayInMillis(),
});

export const getDayInMillisAtSpecificTime = (baseDay?: TimestampInMillis, formatedValye?: string) =>
  moment(baseDay).startOf('day').set('hour', moment(formatedValye, 'HH:mm').hour()).set('minute', moment(formatedValye, 'HH:mm').minute()).valueOf();

export type StartEndDateRange = DateRange | null;

export const THIRTY_SECONDS_IN_MILLIS = 30 * 1000;

export const ONE_MINUTE_IN_MILLIS = 60000;
